import { render, staticRenderFns } from "./related_items_tree_body.vue?vue&type=template&id=4704b6f5&"
import script from "./related_items_tree_body.vue?vue&type=script&lang=js&"
export * from "./related_items_tree_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports